import { getInteractionId } from '@atlaskit/react-ufo/interaction-id-context';
import { getAllFeatureFlags } from '@atlassian/jira-feature-flagging-using-meta';
import type { BM3Metric, BM3Config } from '../types.tsx';

type FeatureFlagValue =
	| boolean
	| string
	| number // eslint-disable-next-line @typescript-eslint/no-explicit-any
	| Record<any, any>
	| 'non_boolean';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const startsAsObject = (value: any): boolean => {
	try {
		if (value.charAt(0) === '{') {
			return true;
		}
	} catch (e) {
		return false;
	}
	return false;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isObject = (value: any): boolean =>
	value && typeof value === 'object' && value.constructor === Object;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isString = (input: any): boolean => {
	let result;
	try {
		result = typeof input === 'string' || input instanceof String;
	} catch (err) {
		// swallow any errors
		result = false;
	}
	return result;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const shouldRedactValue = (value: any): boolean =>
	(isString(value) && startsAsObject(value)) || isObject(value);

export const redactValue = (featureFlagValue: FeatureFlagValue) =>
	shouldRedactValue(featureFlagValue) ? 'non_boolean' : featureFlagValue;

export const bm3FeatureFlagsAccessed: Map<string, FeatureFlagValue | null> = new Map();

/**
 * Checks for an existing interaction
 * before tracking accessed feature flags listed in BM3 by
 * using the `bm3FeatureFlagsAccessed` map.
 *
 * We set the mapped flag value as null for performance reasons,
 * and set it again when the UFO creates its payload to send.
 *
 * WARNING: This function is temporary and will be removed once BM3 is removed.
 *
 */
export const trackBM3FeatureFlagsAccessed = (metric: BM3Metric): void => {
	const interactionId = getInteractionId();
	const currentInteractionId = interactionId.current;
	if (!currentInteractionId) {
		return;
	}

	const data = metric.getData();
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const config = data?.config as BM3Config;

	if (config && config?.featureFlags?.length) {
		const allFeatureFlags = getAllFeatureFlags();

		config.featureFlags.forEach((featureFlagName) => {
			const value = allFeatureFlags[featureFlagName];

			if (value === undefined) return;

			const featureFlagValue = redactValue(value);

			bm3FeatureFlagsAccessed.set(featureFlagName, featureFlagValue);
		});
	}
};
